import { useEffect, useRef, useState } from 'react'
import {
  Content,
  ContentDescription,
  ContentDescriptionText,
  ContentDescriptionTitle,
  ContentIconButtonCollapse,
  ContentTitle,
  StyledLoading,
  StyledSkeleton
} from '../../assets/styles/styles'
import stores from '../../stores/store'
import Params from '../../components/params'
import { ExpandMore } from '@mui/icons-material'

export default function Docs() {
  const { loadingDescription } = stores.DataLoadingStore()
  const { hideHeader, setHideHeader } = stores.DataHideHeaderStore()
  const { jsonSelected: lang } = stores.DataLocaleStore()
  const { content } = stores.DataContentStore()
  const listRef = useRef<HTMLDivElement>(null)
  const { leftMenuItemSelected } = stores.DataLeftMenuSelected()
  const [isMinimized, setIsMinimized] = useState(false)

  useEffect(() => {
    const handleWheel = (event: WheelEvent) => {
      const element = listRef.current
      if (!element) return

      const isAtTop = element.scrollTop === 0
      const isAtBottom =
        element.scrollHeight - element.scrollTop === element.clientHeight

      if ((event.deltaY > 0 && isAtBottom) || (event.deltaY < 0 && isAtTop)) {
        setHideHeader(event.deltaY > 0)
      }
    }

    const element = listRef.current
    element?.addEventListener('wheel', handleWheel)

    return () => {
      element?.removeEventListener('wheel', handleWheel)
    }
  }, [setHideHeader])

  const toggleMinimize = () => {
    setIsMinimized(!isMinimized)
  }

  useEffect(() => {
    setIsMinimized(false)
  }, [content])

  const hasJsonTraInfo =
    content?.descricao?.descricao?.json_traz_quais_informacoes &&
    Array.isArray(content?.descricao?.descricao?.json_traz_quais_informacoes) &&
    content?.descricao?.descricao?.json_traz_quais_informacoes.length > 0

  const renderJsonInformation = () => {
    if (!hasJsonTraInfo) return null

    return content.descricao.descricao.json_traz_quais_informacoes.map(
      (item: any, index: any) => {
        if (
          item.visivelPara !== 'Ambos' &&
          Array.isArray(item.visivelPara) &&
          !item.visivelPara.includes('CPF')
        ) {
          return null
        }

        return (
          <ContentDescription key={`json-info-${index}`}>
            <ContentDescriptionTitle
              style={{ display: 'flex', alignItems: 'center' }}
            >
              {item.svgIcon && (
                <span
                  style={{ marginRight: '10px' }}
                  dangerouslySetInnerHTML={{
                    __html: item.svgIcon.replace(
                      /<svg([^>]*)>/,
                      '<svg$1 style="font-size:26px;width:26px;height:26px;">'
                    )
                  }}
                />
              )}
              {item.titulo}
            </ContentDescriptionTitle>

            {item.descricao && (
              <ContentDescriptionText
                dangerouslySetInnerHTML={{
                  __html: item.descricao
                }}
              />
            )}

            {item.itens && item.itens.length > 0 && (
              <ContentDescriptionText>
                <ul style={{ paddingLeft: '20px', margin: '10px 0' }}>
                  {item.itens.map((listItem: any, listIndex: any) => (
                    <li key={`item-${listIndex}`}>{listItem}</li>
                  ))}
                </ul>
              </ContentDescriptionText>
            )}
          </ContentDescription>
        )
      }
    )
  }

  return (
    <>
      {loadingDescription ? (
        <Content ref={listRef} $hideHeader={hideHeader}>
          <StyledSkeleton width="100%" height="52px" />
          <StyledLoading>
            <StyledSkeleton width="100%" height="32px" />
            <StyledSkeleton width="100%" height="32px" />
            <StyledSkeleton width="100%" height="32px" />
            <StyledSkeleton width="100%" height="32px" />
            <StyledSkeleton width="100%" height="32px" />
          </StyledLoading>
          <StyledSkeleton width="100%" height="52px" />
          <StyledLoading>
            <StyledSkeleton width="100%" height="32px" />
            <StyledSkeleton width="100%" height="32px" />
            <StyledSkeleton width="100%" height="32px" />
            <StyledSkeleton width="100%" height="32px" />
            <StyledSkeleton width="100%" height="32px" />
          </StyledLoading>
        </Content>
      ) : (
        <Content ref={listRef} $hideHeader={hideHeader}>
          <ContentTitle>
            {leftMenuItemSelected}

            <ContentIconButtonCollapse
              onClick={toggleMinimize}
              $isMinimized={isMinimized}
            >
              <ExpandMore />
            </ContentIconButtonCollapse>
          </ContentTitle>

          {!isMinimized && (
            <>
              {content?.descricao?.descricao?.o_que_e?.descricao && (
                <ContentDescription>
                  <ContentDescriptionTitle>
                    {lang.content.whatIsIt}
                  </ContentDescriptionTitle>
                  <ContentDescriptionText
                    dangerouslySetInnerHTML={{
                      __html: content?.descricao?.descricao?.o_que_e?.descricao
                        ? content?.descricao?.descricao?.o_que_e?.descricao
                        : lang.content.messageEmpty
                    }}
                  />
                </ContentDescription>
              )}

              {content?.descricao?.descricao_principal && (
                <ContentDescription>
                  <ContentDescriptionTitle>
                    {lang.content.description}
                  </ContentDescriptionTitle>
                  <ContentDescriptionText
                    dangerouslySetInnerHTML={{
                      __html: content?.descricao?.descricao_principal
                        ? content.descricao.descricao_principal
                        : lang.content.messageEmpty
                    }}
                  />
                </ContentDescription>
              )}

              {hasJsonTraInfo
                ? renderJsonInformation()
                : content?.descricao?.descricao?.traz_quais_informacoes
                    ?.descricao && (
                    <ContentDescription>
                      <ContentDescriptionTitle>
                        {lang.content.whatInformationItProvides}
                      </ContentDescriptionTitle>
                      <ContentDescriptionText
                        dangerouslySetInnerHTML={{
                          __html: content?.descricao?.descricao
                            ?.traz_quais_informacoes?.descricao
                            ? content.descricao.descricao.traz_quais_informacoes
                                .descricao
                            : lang.content.messageEmpty
                        }}
                      />
                    </ContentDescription>
                  )}
            </>
          )}
          <Params />
        </Content>
      )}
    </>
  )
}
